export const settingsPopOverConfig = {
    popOverSelector: '.RC-customizeSettings',
    openAreaSelectors: ['.js-RC-settingsPopover__openBtn'],
    closeAreaSelectors: ['.js-RC-settingsPopover__shadowbox', '.js-RC-customizeSettings__popoverBtn'],
    activeClass: 'RC-customizeSettings_active',
    onOpen() {
        this.name = 'Settings';
    }
};



// WEBPACK FOOTER //
// ./lib/js/modules/customizeSettings/settingsPopOver.config.js